import assignWith from 'lodash/assignWith';
import Dealer from 'models/dealer';
import dealerApi from 'api/dealer';
import events from 'lib/events';
import FooterButton from 'components/layout/footerButton';
import FooterEditButton from 'components/layout/footerEditButton';
import hopscotch from 'hopscotch';
import PageFooter from 'components/layout/pageFooter';
import PreferenceOptions from './AnalysisPreferences/PreferenceOptions';
import ProductApi from 'api/product';
import BranchApi from 'api/branch';
import React from 'react';
import session from 'services/sessionService';
import ValidationGroup from 'helpers/validation';
import {dealerAdminTourFormat, userLevels, countries} from 'helpers/constants';
import {intlShape, injectIntl} from 'react-intl';
import {deleteSuggestedProducts, getSuggestedProducts} from 'api/suggestedProduct';
import {getNaturalChemistryProducts} from 'helpers/suggestedProductList';


let assignHelper = (defaultVal, newVal) => defaultVal && (newVal === null || newVal === undefined) ? defaultVal : newVal;

class AnalysisPreferences extends React.Component {
  constructor(props) {
    super(props);
    let newDealer = new Dealer({
      balanceCHTo: 'Use LSI',
      inSeasonTABalanceTarget: '135',
      smartShockMinSize: '1',
      nonFoamingAlgicide: 40,
      defaultHazyProduct: 60,
      overrideOxidizer: 17,
    });

    this.state = {
      branches: [],
      dealer: newDealer.clone(),
      dealerWorkingCopy: newDealer.clone(),
      edit: false,
      originalSuggestedProducts: null,
      products: [],
      suggestedProducts: null,
    };
  }

  componentWillMount() {
    this.group = new ValidationGroup(this.savePrefs);
  }

  componentDidMount() {
    Promise.all([
      BranchApi.getFullBranches(),
      dealerApi.getDealer(session.getUser().dealerId),
      ProductApi.getProducts(),
      getSuggestedProducts(),
    ])
    .then(([branches, dealer, products, suggestedProducts]) => {
      // Merge with existing one so if values are somehow null (old/imported/etc) then it gets set to default.
      const naturalChemistyEnabled = (branches || []).some(b => !!b.naturalChemistry);

      if(suggestedProducts.length) {
        if(!naturalChemistyEnabled) {
          let {country} = dealer;
          const ncProducts = getNaturalChemistryProducts(country || countries.US).map(ncp => ncp.id);


          suggestedProducts = suggestedProducts.filter(p => !ncProducts.includes(p.product));

          // If Pool First Aid has been chose but NC is not enabled default
          // to Pool Complete 911 (US) or Natural Clarifier (Canada)
          if(dealer.defaultHazyProduct ===  205) {
            dealer.defaultHazyProduct = dealer.country === countries.US ? 223 : 60;
          }
        }
        this.updateSuggestedProducts(suggestedProducts, true);
      }

      this.setState({
        branches,
        ncProductsIntegration: naturalChemistyEnabled,
        dealer: assignWith(this.state.dealer, dealer.clone(), assignHelper),
        dealerWorkingCopy: assignWith(this.state.dealerWorkingCopy, dealer.clone(), assignHelper),
        products,
      });
    });

    if (hopscotch.getState() === 'dealerAdmin:16') {
      hopscotch.startTour(dealerAdminTourFormat(this.props.intl.formatMessage), 16);
    }
  }

  componentWillUnmount() {
    if (hopscotch.isActive && window.location.hash !== '#settings/customer' && window.location.hash !== '#tools') {
      hopscotch.endTour();
    }
  }

  getProductSuggestions = () => {
    const {dealer, ncProductsIntegration} = this.state;

    getSuggestedProducts()
      .then(result => {
        if(result.length) {
          if(!ncProductsIntegration) {
            let {country} = dealer;
            const ncProducts = getNaturalChemistryProducts(country || countries.US).map(ncp => ncp.id);

            result = result.filter(p => !ncProducts.includes(p.product));
          }
          this.updateSuggestedProducts(result, true);
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  cancelEdit = () => {
    this.setState({
      dealerWorkingCopy: this.state.dealer.clone(),
      edit: false,
    });
    if(!this.state.suggestedProducts || !this.state.suggestedProducts.length) {
      this.setState({suggestedProducts: this.state.originalSuggestedProducts});
    }
  };

  dataChanged = (e) => {
    let dealer = this.state.dealerWorkingCopy.clone();

    dealer[e.key] = e.value;

    this.setState({dealerWorkingCopy: dealer});
  };

  savePrefs = () => {
    dealerApi.saveDealer(this.state.dealerWorkingCopy)
      .then(dealer => {
        this.setState({
          dealer: assignWith(this.state.dealer, dealer.clone(), assignHelper),
          dealerWorkingCopy: assignWith(this.state.dealerWorkingCopy, dealer.clone(), assignHelper),
          edit: false,
        });
      })
      .catch(err => events.publish('error.user', {message: err}));

    if(!this.state.suggestedProducts || !this.state.suggestedProducts.length) {
      deleteSuggestedProducts()
        .then(() => this.setState({suggestedProducts: null}))
        .catch(e => console.error(e));
    }
  };

  startEdit = () => {
    this.setState({
      dealerWorkingCopy: this.state.dealer.clone(),
      edit: true,
    });
  };

  updateSuggestedProducts = (products, updateOriginal) => {
    let original = updateOriginal ? products : this.state.originalSuggestedProducts;

    this.setState({
      originalSuggestedProducts: original,
      suggestedProducts: products,
    });
  };

  render() {
    let footer;

    if (session.getUser().privileges.level >= userLevels.dealerAdmin) {
      footer =
        <PageFooter>
          <FooterEditButton className='footer-item'
                            onCancel={this.cancelEdit} onSave={this.group.validate}
                            onEdit={this.startEdit} editMode={this.state.edit} />
        </PageFooter>
      ;
    }

    return (
      <div className='analysis-preferences'>
        <PreferenceOptions
          branches={this.state.branches}
          dataChanged={this.dataChanged}
          dealer={this.state.dealerWorkingCopy}
          edit={this.state.edit}
          group={this.group}
          ncProductsIntegration={this.state.ncProductsIntegration}
          products={this.state.products}
          suggestedProducts={this.state.suggestedProducts}
          updateSuggestedProducts={this.updateSuggestedProducts}
        />
        <div className='clearfix' />
        {footer}
      </div>
    );
  }
}

export default injectIntl(AnalysisPreferences);
